import {
  REJECT_PAYMENT,
  ERROR_PSE_PAYMENT,
  SET_ERROR_PAYMENT,
} from "./customTextLabels";

export const fnPaymentShoppign = (data, setError, setOpenModal) => {
  if (data?.status === "success") {
    const { payment_status, payment_type, pse_link } = data?.data;
    const APPROVED_STATUS = "aprobado";
    const REJECTED_STATUS = "rechazado";
    const PSE_PAYMENT = "pse";

    if (payment_status === APPROVED_STATUS) {
      setOpenModal({
        open: true,
        data: data?.data,
      });
    }

    if (payment_status === REJECTED_STATUS) {
      return setError(SET_ERROR_PAYMENT, { message: REJECT_PAYMENT });
    }

    if (payment_type === PSE_PAYMENT && !pse_link) {
      return setError(SET_ERROR_PAYMENT, { message: ERROR_PSE_PAYMENT });
    }

    if (pse_link && payment_type === PSE_PAYMENT) {
      return window.location.replace(pse_link);
    }

    return setError(SET_ERROR_PAYMENT, { message: 'Ocurrio un error, por favor intenta mas tarde' });
  }

  if (data?.status === "error") {
    const message = data?.message[0]?.message ?? REJECT_PAYMENT;
    setError(SET_ERROR_PAYMENT, { message });
  }
};
